import { from as envFrom } from 'env-var';

import { devConfig } from './dev';

const GLOBAL_PROPERTY = 'am-config';

interface ExtendedWindow extends Window {
  [GLOBAL_PROPERTY]: typeof devConfig;
}

declare const window: ExtendedWindow;

const env = envFrom(window[GLOBAL_PROPERTY] ?? devConfig);

/** Generic settings */
export const RELEASE_VERSION = env
  .get('RELEASE_VERSION')
  .default('unknown')
  .asString();

/** portal api base url */
export const PORTAL_API_URL = env
  .get('PORTAL_API_URL')
  .required()
  .asUrlString();

/**
 * portal gateway base url.
 * If no override is defined, the current portal-next URL is used.
 */
export const PORTAL_GATEWAY_API_BASE_URL =
  env.get('PORTAL_GATEWAY_API_BASE_URL').asString() || window.location.origin;

export const SENTRY_ENABLED = env
  .get('SENTRY_ENABLED')
  .default('false')
  .asBool();

export const SENTRY_DSN = env.get('SENTRY_DSN').asString();
export const SENTRY_MASK_ALL_TEXT = env
  .get('SENTRY_MASK_ALL_TEXT')
  .default('true')
  .asBool();

export const SENTRY_ENVIRONMENT = env
  .get('SENTRY_ENVIRONMENT')
  .default('')
  .asString();

export const NODE_ENV = env.get('NODE_ENV').default('development').asString();

export const ROUTE_BASE_NAME = env
  .get('ROUTE_BASE_NAME')
  .default('')
  .asString();

/** Ag-grid license key */
export const AG_GRID_LICENSE_KEY = env
  .get('AG_GRID_LICENSE_KEY')
  .default('')
  .asString();

/** Download settings */
export const DOWNLOAD_DATE_PREFIX_FORMAT = env
  .get('DOWNLOAD_DATE_PREFIX_FORMAT')
  .default('YYYY-MM-DD HH-mm-ss')
  .asString();
